import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

const base = `${baseUrl}`;

export function getCaseList(token) {
  return axios.get(`${baseUrl}/cases/list`, {
    headers: {
      authorization: token,
    },
  });
}

export function createCase(token, data) {
  return axios.post(`${baseUrl}/case`, data, {
    headers: {
      authorization: token,
    },
  });
}

export function resendRespondentInvitation(token, caseId) {
  return axios.post(`${baseUrl}/case/${caseId}/invite-respondent`, {}, {
    headers: {
      authorization: token,
    },
  });
}

export function getCases(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/cases${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getCaseById(token, caseId) {
  return axios.get(`${baseUrl}/case/${caseId}`, {
    headers: {
      authorization: token,
    },
  });
}

export function updateCaseById(token, caseId, data) {
  return axios.patch(`${baseUrl}/case/${caseId}`, data, {
    headers: {
      authorization: token,
    },
  });
}

export function deleteCaseById(token, caseId) {
  return axios.delete(`${baseUrl}/case/user/${caseId}`, {
    headers: {
      authorization: token,
    },
  });
}
////  question answer submit///////
export function postQuestionsAnswers(token, data) {
  return axios.post(`${baseUrl}/case/submitQuestionAnswers`, data, {
    headers: {
      authorization: token,
    },
  });
}

export function postCheckApproval(token, data) {
  return axios.post(`${baseUrl}/case/checkQuestionnaireApproval`, data, {
    headers: {
      authorization: token,
    },
  });
}
